import { AddElementsPanelOptions } from '@wix/editor-platform-sdk-types';
import {
  FullNormalizedItem,
  NormalizedData,
  SectionsItems,
} from '@wix/editor-platform-host-integration-apis';

import { addCategoriesChildrenItem, updateNestedObjectValue } from '.';

export const handleItemWithCategoryId = (
  item: FullNormalizedItem,
  accumulator: NormalizedData,
  options: AddElementsPanelOptions,
): NormalizedData => {
  return updateNestedObjectValue<
    NormalizedData,
    SectionsItems['categoriesWithItems']
  >(
    accumulator,
    ['notInSectionItems', 'categoriesWithItems'],
    (categoriesWithItems) =>
      addCategoriesChildrenItem(
        item,
        options.categoriesData,
        categoriesWithItems,
      ),
  );
};

export const handleItemWithSectionId = (
  item: FullNormalizedItem,
  accumulator: NormalizedData,
  options: AddElementsPanelOptions,
): NormalizedData => {
  const sectionId = item.sectionId ?? '';

  if (item.categoryId) {
    return updateNestedObjectValue<
      NormalizedData,
      SectionsItems['categoriesWithItems']
    >(
      accumulator,
      ['sectionWithItems', sectionId, 'categoriesWithItems'],
      (categoriesWithItems) =>
        addCategoriesChildrenItem(
          item,
          options.categoriesData,
          categoriesWithItems,
        ),
    );
  }

  return updateNestedObjectValue<
    NormalizedData,
    SectionsItems['unCategorizedItems']
  >(
    accumulator,
    ['sectionWithItems', sectionId, 'unCategorizedItems'],
    (unCategorizedItems) => [...unCategorizedItems, item],
  );
};

export const handleDefaultItemCase = (
  item: FullNormalizedItem,
  accumulator: NormalizedData,
): NormalizedData => {
  return updateNestedObjectValue<
    NormalizedData,
    SectionsItems['unCategorizedItems']
  >(
    accumulator,
    ['notInSectionItems', 'unCategorizedItems'],
    (unCategorizedItems) => [...unCategorizedItems, item],
  );
};
